import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins'
import './style.scss'


let branding = localStorage.getItem('branding')

if (branding == null) {
  branding = 'jimber';
  localStorage.setItem('branding', branding)
}

import(`../public/themes/${branding}/index.css`)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  console.log(`to.name == ${to.name}`)
  if ((to.name !== 'initial' && to.name !== 'error' && to.name !== 'verifyemail' && to.name !== 'timeout' && to.name !== 'resetseedphrase') && !store.state.doubleName) {
    next({
      name: 'initial'
    })
  } else {
    next()
  }
})

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
